import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Col} from 'reactstrap';
import BankAccount from './BankAccount';

export default class BankAccounts extends Component{
  render(){
    return(
      <Col xs={12} md={12} className="section bank-account-container bank-transfer">
        {
          this.props.data.map((bank,index)=><BankAccount {...bank} key={index}/>)
        }                
      </Col>
    )
  }
}